<template>
  <div class="h-dialogContainer"> 
    <form id='addTrunk'>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.trunkCode')}}:</div>
          <ejs-dropdownlist
            name='trunkCode'
            :placeholder="trunkTypePlaceholder"
            :dataSource="typeData"
            v-model="trunkinfo.typeCode"
            :fields="typeFields"
            :change="onTypeChange"
            :readonly="readTrunkCode"
            :noRecordsTemplate="noRecordsTemplate"
          ></ejs-dropdownlist>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.trunkName')}}:</div>
          <input
            name='trunkName'
            class="e-input"
            :placeholder="trunkNamePlaceholder"
            type="text"
            v-model="trunkinfo.name"
          />
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.physicalIP')}}:</div>
            <input
              name="trunkIP"
              class="e-input"
              :placeholder="neIPPlaceholder"
              type="text"
              v-model="trunkinfo.ip"
            />
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.physicalPort')}}:</div>
          <input
            name='trunkPort'
            class="e-input"
            :placeholder="nePortPlaceholder"
            type="text"
            v-model="trunkinfo.port"
          />
        </div>
      </div>
    </div>
  <div class="row h-row-inputBox">
    <div class="col-sm-6 h-col-inputBox">
      <div>
        <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devSoftVersion')}}:</div>
        <ejs-dropdownlist ref='vesion'
          name='devSoftVersion'
          :placeholder="trunkSoftVersionPlaceholder"
          :dataSource="visionData"
          v-model="trunkinfo.softwareVersion"
          :fields="visonFields"
          :readonly="readSoftware"
          :change="onSoftVersionChange"
          :noRecordsTemplate="noRecordsTemplate"
        ></ejs-dropdownlist>
      </div>
    </div>
  </div>
    <div class="row h-row-inputBox">
      <div class="h-col-inputBox-a">
        <div class="h-inputLit">{{this.$t('Topo.trunkDescription')}}:</div>
        <ejs-textbox
          name='trunkDescription'
          multiline="true"
          :placeholder="trunkDescriptionPlaceholder"
          v-model="trunkinfo.description"
        ></ejs-textbox>
      </div>
    </div>
    <div class="h-clear-rowMg"></div>
    </form>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import { EventBus } from '../../plugins/eventBus';

export default {
  name: 'add-trunk',
  components: {},
  data() {
    return {
      trunkNamePlaceholder: this.$t('Topo.trunkName'),
      trunkTypePlaceholder: this.$t('Topo.trunkCode'),
      neIPPlaceholder:this.$t('Topo.physicalIP'),
      nePortPlaceholder: this.$t('Topo.physicalPort'),
      trunkDescriptionPlaceholder: this.$t('Topo.trunkDescription'),
      noRecordsTemplate: this.$t('Topo.noData'),
      trunkSoftVersionPlaceholder: this.$t('Topo.trunkSelect'),
      trunkinfo: {
        id: '',
        name: '',
        typeCode: '',
        ip: '',     
        port: '',
        positionX: 225,
        positionY: 226,
        softwareVersion:'',
        displaySoftwareVersion:'',
        description: ''
      },
      typeData: [],
      typeFields: { value: 'typeCode', text: 'nameKey' },
      visionData: [],
      visonFields: { value: 'softwareVersion', text: 'displaySoftwareVersion' },
      readTrunkCode: false,
      readSoftware: false,
      validationOption: {
        customPlacement(inputElement, errorElement) {
            errorElement.style.float = 'left';
            inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {                    
            trunkCode: {                        
                required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            trunkName: {
                required: [true, `${this.$t('Pm.alertRequired')}`],
                regex: [/^(^\S)/, `${this.$t('Topo.noEmptyStart')}`],
                maxLength: [30, `${this.$t('Pm.alertMaxLength')}64`],
            },
            devSoftVersion: {                        
                required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            trunkPort: {                        
                required: [true, `${this.$t('Pm.alertRequired')}`],
                regex: ['^\\d*$', `${this.$t('Topo.invalidInt')}`],
                range: [[1, 65535], `${this.$t('Topo.inputRangeIllegal')}`],  
            },
            trunkIP: {                        
                required: [true, `${this.$t('Pm.alertRequired')}`],
                regex: [/^(25[0-5]|2[0-4]\d|[0-1]?\d?\d)(\.(25[0-5]|2[0-4]\d|[0-1]?\d?\d)){3}$/, `${this.$t('Topo.ipIllegal')}`]
            },
            trunkDescription: {            
                maxLength: [255, `${this.$t('Pm.alertMaxLength')}255`],
            },
        }
    },
      trunkTypemap: new Map()
        .set( 20001 , this.$t('Topo.trunkMC_CF'))
        .set( 20002 , this.$t('Topo.trunkHyTalk')),
    };
  },

  mounted() {
    this.initData();
    this.bindValidate();
  },

  methods: {
    outputs(isFromGraph, positionX, positionY) {
      //表单验证
      if(!this.validate()){
          return;
      } 
      const trunkInfo = {
        ...this.trunkinfo,
        typeCode: this.trunkinfo.typeCode.toString(),
      }
      // 添加集群  
        if (isFromGraph) {
          this.trunkinfo.positionX = positionX;
          this.trunkinfo.positionY = positionY;
        }
        this.axios.post('/lte/ems/topo/trunk/addTrunk', trunkInfo).then((response) => {
          if(response.data === undefined){
            return;
          }
          if( response.status ===200){
            if (response.data.errorCode === 'SUCCESS') {
              EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
              this.closeWindow();
              return;
            } else {
              EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
              this.closeWindow();
            }
          }
        });
    },

    onTypeChange(args1){
      const This = this;
      const trunkType = parseInt(args1.value);  
      const visionDataTemp=[];
      console.log('This.trunkinfo.id',This.trunkinfo.id)
      if(This.trunkinfo.id === ''){
      This.$axios.get(`/lte/ems/topo/trunk/trunkSoftVersion/${trunkType}`).then(response => {
        if(response.data === undefined){
          return;
        }
        if( response.status ===200){
          if (response.data.errorCode === 'SUCCESS') {
            for(var k in response.data.resultVal){
              visionDataTemp.push({
                softwareVersion:k,
                displaySoftwareVersion:response.data.resultVal[k]
              })
            }
            This.visionData = visionDataTemp;
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        }
      });
      }
    },

    onSoftVersionChange(e){
      if(e.itemData !== null){
        this.trunkinfo.displaySoftwareVersion=e.itemData.displaySoftwareVersion;
      }   
    },
    trunkTypeFormatter(typeCode) {
      return this.trunkTypemap.get(typeCode);
    },
    closeWindow() {
      console.log('close');
      this.$emit('close');
    },
    initData(data) {
      // 新建设备专用
       console.log('trunkData',data)
      this.queryTrunkType();       
      this.trunkinfo = {
        id: '',
        name: '',
        typeCode: '',
        ip: '',     
        port: '',
        softwareVersion:'',
        displaySoftwareVersion:'',
        description: ''
      };
    },

    // 新建集群时去后台查集群类型
    queryTrunkType() {
      const This = this;
      This.$axios.get('/lte/ems/topo/trunk/findTrunkType').then(response => {
          if(response.data === undefined){
            return;
          }
          if( response.status ===200){
            if (response.data.errorCode === 'SUCCESS') {
              This.typeData = response.data.resultVal;
            } else {
              EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
            }
          }
      });
    },
    bindValidate() {            
      this.formObj = new FormValidator('#addTrunk', this.validationOption);
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    }
  }
};
</script>
